import React from "react";
import { GatsbyBrowser } from "gatsby";
import WrapPageElement from "./src/components/general/WrapPageElement/WrapPageElement";

export default (({ element, props }) => (
  <WrapPageElement pageContext={props.pageContext} location={props.location}>
    {element}
  </WrapPageElement>
)) as GatsbyBrowser["wrapPageElement"];
